import { IAppContext, ICareerPageSettingDTO } from 'wisestep-api';

const convertResponseToData = (response: ICareerPageSettingDTO) => {
  const CareerPageSettings: IAppContext = {
    appearanceSettings: JSON.parse(response.appearanceSettings),
    candidatesSettings: JSON.parse(response.candidatesSettings),
    generalSettings: JSON.parse(response.generalSettings),
    integrationSettings: JSON.parse(response.integrationSettings),
    isPreview: false,
    jobsSettings: JSON.parse(response.jobsSettings),
    slug: response.slug,
    userId: response.userId,
    domain: response.domain,
    emailSettings: response.emailSettings ? JSON.parse(response.emailSettings) : {},
  };
  return CareerPageSettings;
};
export default convertResponseToData;
